<template>
  <v-snackbar v-model="appStore.snackbar" :timeout="appStore.timeout">
    {{ appStore.snackbarMessage }}
    <template v-slot:actions>
      <v-btn color="pink" variant="text" @click="appStore.closeSnackbar">
        {{ t('common.close') }}
      </v-btn>
      <v-btn
        v-if="appStore.snackbarEnableAccept"
        color="green"
        variant="text"
        @click="appStore.acceptSnackbar"
      >
        {{ t('common.update') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useAppGlobalStore } from '@/store/app'
const appStore = useAppGlobalStore()
const { t } = useI18n()
</script>
